export interface GridViewConditionModel {
    columnName: string;
    value: any;
    operator: string;
}

export interface GridViewActionModel {
    label: string;
    eventName: string; 
    hideColumn?:boolean
    conditionsToHide?: GridViewConditionModel[];
}